import {
  Button,
  Container,
  Image,
  Navbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import GlobalSearchBox from "./components/GlobalSearchBox";
import DataDate from "./DataDate";
import LoginButton from "./LoginButton";

const Header = () => {
  const location = useLocation();

  return (
    <Navbar
      as="header"
      sticky="top"
      role="menubar"
      className="d-lg-flex d-none border-bottom"
    >
      <Container fluid>
        <Navbar.Brand
          as={Link}
          to="/dashboard"
          className="bg-light p-1 rounded"
        >
          <Image src="/logo.svg" height="40" alt="AdviceCloud logo" />
        </Navbar.Brand>
        <GlobalSearchBox />
        <div className="d-flex align-items-end gap-5">
          <DataDate />
          <OverlayTrigger placement="bottom" overlay={<Tooltip>Help</Tooltip>}>
            <Button
              variant="link"
              className="p-0 text-body"
              onClick={() =>
                window.open(
                  `/help?from=${encodeURIComponent(location.pathname)}`,
                  "_blank",
                )
              }
            >
              <i className="bi bi-question-circle fs-5" />
            </Button>
          </OverlayTrigger>
          <LoginButton />
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
